import { render, staticRenderFns } from "./AvalicaoMacroscopica-comp.vue?vue&type=template&id=498f3759&scoped=true&"
import script from "./AvalicaoMacroscopica-comp.vue?vue&type=script&lang=js&"
export * from "./AvalicaoMacroscopica-comp.vue?vue&type=script&lang=js&"
import style0 from "./AvalicaoMacroscopica-comp.vue?vue&type=style&index=0&id=498f3759&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498f3759",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCardText,VCheckbox,VCol,VContainer,VForm,VIcon,VRow,VTextarea})
